import classnames from 'classnames';
import { Json } from 'shared-base/dist/types';
import Picker from '../Picker/Picker';
import Slider from '../Slider/Slider';
import Switch from '../Switch/Switch';
import { Wrapper } from './Parameter.style';
import { fixLabel } from './Parameter.utils';

export type ParameterProps = {
  param: Json;
  onChange: (id: string, value: string | number | boolean) => void;
  onSet: (id: string, value: string | number | boolean) => void;
};

export function Parameter(props: ParameterProps) {
  const { param } = props;
  const { id, name = '' } = param;

  function onChange(value: string | number | boolean) {
    props.onChange(id, value);
  }

  function onSet(value: string | number | boolean) {
    props.onSet(id, value);
  }

  function renderInner() {
    switch (param.type) {
      case 'picker':
        return <Picker onChange={onChange} onSet={onSet} param={param} />;
      case 'slider':
        return <Slider onChange={onChange} onSet={onSet} param={param} />;
      case 'toggle':
        return <Switch onChange={onChange} onSet={onSet} param={param} />;
    }
  }

  const className = classnames('Parameter-wrapper', param.type, {});

  return (
    <Wrapper className={className} data-testid='Parameter-wrapper'>
      <label>{fixLabel(name)}</label>
      {renderInner()}
    </Wrapper>
  );
}

export default Parameter;
